var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { apiGetOneRfp } from '@/actions/ProfessionalRfpActions';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { RFP_PROFESSIONAL_DATA_TYPE_UNAPPROVED } from '@/utils/constants/rfp/professional/dataType';
export const useRfpOneProfessional = (args) => {
    const { afterCallbackInApproved, afterCallbackInUnapproved } = args || {};
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    // 案件ID
    const { id = '' } = useParams();
    // 案件詳細データ
    const rfp = useTypeSelector((state) => state.professionalRfp.one[id] || null);
    /**
     * 案件詳細データ 取得
     */
    const rowFetchRfpOne = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const { payload } = yield wrapDispatch(dispatch, apiGetOneRfp({ path: { id } }, { id }));
        // 未承認判定
        const unapproved = payload.data_type === RFP_PROFESSIONAL_DATA_TYPE_UNAPPROVED.value;
        // callback 実行: 未承認時
        if (unapproved && afterCallbackInUnapproved) {
            yield afterCallbackInUnapproved(dispatch, payload, unmountRef);
        }
        // callback 実行: 承認時
        if (!unapproved && afterCallbackInApproved) {
            yield afterCallbackInApproved(dispatch, payload, unmountRef);
        }
    }), [
        afterCallbackInApproved,
        afterCallbackInUnapproved,
        dispatch,
        id,
        unmountRef,
    ]);
    // ローディング制御
    const { callbackPromiseEvent: fetchRfpOne, doing: loading } = usePromiseDoingCallback({
        initialDoingState: true,
        promiseEvent: rowFetchRfpOne,
        unmountRef,
    });
    useEffect(() => {
        fetchRfpOne();
    }, [fetchRfpOne]);
    return {
        id,
        loading,
        rfp,
    };
};
